// Label de section HUD — barre accent + titre mono uppercase.
import type { ReactNode } from 'react'

export function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 14 }}>
      <div style={{
        width: 3, height: 14, borderRadius: 2, flexShrink: 0,
        background: 'linear-gradient(180deg, var(--accent), var(--accent-cyan))',
      }} />
      <h2 className="font-display" style={{
        fontSize: '11px', fontWeight: 600, letterSpacing: '0.14em',
        color: 'var(--text-secondary)', margin: 0, textTransform: 'uppercase',
      }}>
        {children}
      </h2>
    </div>
  )
}
